import React from 'react'
import PropTypes from 'prop-types'
import ContentBox from '../../../layout/component/ContentBox'
import Row from '../../../bootstrap/component/Row'
import Column from '../../../bootstrap/component/Column'
import Select from '../../../form/component/Select'
import LabelInput from '../../../form/component/LabelInput'
import { COMPANY_CODE_SELECT_VALUE_LIST } from '../../../internationalization/const'
import { STATE_RESPONSIBLE_SELECT } from '../../../process/state/state-responsible/const'
import { COUNTRY_CODE_LIST } from '../../../internationalization/const'
import { renderProcessName } from '../../../process/util/names'


const StateResponsibleSelector = ({ userSelection, processNameList, changeUserSelection, getStateAnalytics }) => {
    const processNameSelect = processNameList.map(name => ({
        id: name,
        value: renderProcessName(name),
    }))

    return (<ContentBox title="Process Dashboard">

        <Row>
            <Column size={3}>
                <LabelInput label="Responsible">
                    <Select
                        object={userSelection}
                        name="responsible"
                        addEmpty={true}
                        valueList={STATE_RESPONSIBLE_SELECT}
                        onChange={(name, value) => {
                            changeUserSelection(name, value)
                            getStateAnalytics()
                        }}/>
                </LabelInput>
            </Column>
            <Column size={3}>
                <LabelInput label="Process">
                    <Select
                        object={userSelection}
                        name="processName"
                        addEmpty={true}
                        valueList={processNameSelect}
                        onChange={(name, value) => {
                            value = value || null
                            changeUserSelection(name, value)
                            getStateAnalytics()
                        }}/>
                </LabelInput>
            </Column>
            <Column size={3}>
                <LabelInput label="Company">
                    <Select
                        object={userSelection}
                        name="companyCode"
                        addEmpty={true}
                        valueList={COMPANY_CODE_SELECT_VALUE_LIST}
                        onChange={(name, value) => {
                            value = value || null
                            changeUserSelection(name, value)
                            getStateAnalytics()
                        }}/>
                </LabelInput>
            </Column>
            <Column size={3}>
                <LabelInput label="Country">
                    <Select
                        object={userSelection}
                        name="countryCode"
                        addEmpty={true}
                        valueList={COUNTRY_CODE_LIST}
                        onChange={(name, value) => {
                            value = value || null
                            changeUserSelection(name, value)
                            getStateAnalytics()
                        }}/>
                </LabelInput>
            </Column>
        </Row>


    </ContentBox>)
}

StateResponsibleSelector.propTypes = {
    userSelection: PropTypes.object.isRequired,
    getStateAnalytics: PropTypes.func.isRequired,
    changeUserSelection: PropTypes.func.isRequired,
    processNameList: PropTypes.array.isRequired,
}


export default StateResponsibleSelector



// WEBPACK FOOTER //
// ./src/modules/analytics/component/state-responsible/StateResponsibleSelector.js